import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { CircleLoader } from 'components/loaders'
import Lightbox from 'react-images'
import styles from './image-gallery.styl'
import { apiDownloadFile } from 'helpers/decorators/api'
import { SUPPORTED_IMAGES_EXTENSIONS } from 'constants/enums'

@apiDownloadFile()
class ImageGallery extends PureComponent {
  static propTypes = {
    small: PropTypes.bool,
    urls: PropTypes.array,
    onDownloadFile: PropTypes.func,
    files: PropTypes.object
  }

  static defaultProps = {
    urls: []
  }

  state = {
    isOpen: false,
    currentImage: 0,
    error: false
  }

  componentDidMount() {
    const { urls } = this.props

    urls.forEach(url => this.props.onDownloadFile(url))
  }

  handleOpenLightbox = index => {
    this.setState({
      isOpen: !this.state.isOpen,
      currentImage: index
    })
  }

  handleCloseLightbox = () => {
    this.setState({
      isOpen: false
    })
  }

  handleNext = () => {
    this.setState({
      currentImage: this.state.currentImage + 1
    })
  }

  handlePrev = () => {
    this.setState({
      currentImage: this.state.currentImage - 1
    })
  }

  handleGoToImage = index => {
    this.setState({
      currentImage: index
    })
  }

  render() {
    const { small, urls, files } = this.props
    const { isOpen, currentImage, error } = this.state
    let size = 100

    if (small) {
      size = 60
    }

    const downloadedFiles = urls.map(url => ({
      src: get(files[url], 'fileLocalUrl') || '',
      type: get(files[url], 'type') || ''
    }))

    const images = downloadedFiles.filter(item =>
      SUPPORTED_IMAGES_EXTENSIONS.some(ext => item.type === ext)
    )

    return (
      <div className={styles.gallery}>
        {urls.map((image, index) => (
          <div key={index} className={styles.imageThumb}>
            {get(files[image], 'loading') && <CircleLoader size={26} inline />}
            {!get(files[image], 'loading') && (
              <img
                src={get(files[image], 'fileLocalUrl')}
                height={size}
                onClick={() => this.handleOpenLightbox(index)}
              />
            )}
          </div>
        ))}
        {error && (
          <FormattedMessage
            id="global.something_went_wrong"
            defaultMessage="Something went wrong"
          />
        )}
        <Lightbox
          images={images}
          currentImage={currentImage}
          isOpen={isOpen}
          onClose={this.handleCloseLightbox}
          onClickNext={this.handleNext}
          onClickPrev={this.handlePrev}
          onClickThumbnail={this.handleGoToImage}
          showThumbnails
        />
      </div>
    )
  }
}

export default ImageGallery
